import { createReducer } from '@reduxjs/toolkit';

import { RegionWithId } from '../models/region';
import { getRegionsByCountry, resetRegions, searchRegions } from '../actions/region-actions';

export interface RegionsReducerState {
    regionsByCountry: Record<string, RegionWithId[]>;
    searchResult: RegionWithId[];
    countryCode?: string;
    requesting: boolean;
}

const initialRegionReducerState: RegionsReducerState = {
    regionsByCountry: {},
    searchResult: [],
    requesting: false,
};

export const regionsReducer = createReducer(initialRegionReducerState, builder =>
    builder
        .addCase(getRegionsByCountry.pending, state => {
            state.requesting = true;
        })
        .addCase(getRegionsByCountry.fulfilled, (state, action) => {
            state.regionsByCountry = action.payload.regions.reduce<Record<string, RegionWithId[]>>((acc, region) => {
                if (!acc[action.payload.countryCode]) {
                    acc[action.payload.countryCode] = [];
                }

                acc[action.payload.countryCode].push(region);

                return acc;
            }, {});
            state.countryCode = action.payload.countryCode;
            state.requesting = false;
        })
        .addCase(resetRegions.fulfilled, state => {
            state = initialRegionReducerState;
        })
        .addCase(searchRegions.pending, state => {
            state.requesting = true;
        })
        .addCase(searchRegions.fulfilled, (state, action) => {
            state.searchResult = action.payload.items;
        })
);
